"use client";
import { jsx, Fragment } from "react/jsx-runtime";
const AudiFont = () => {
  async function importFont() {
    await import("./audi/index.js");
  }
  void importFont();
  return jsx(Fragment, {});
};
const AutoriaFont = () => {
  async function importFont() {
    await import("./autoria/index.js");
  }
  void importFont();
  return jsx(Fragment, {});
};
const BilholdFont = () => {
  async function importFont() {
    await import("./bilhold/index.js");
  }
  void importFont();
  return jsx(Fragment, {});
};
const CupraFont = () => {
  async function importFont() {
    await import("./cupra/index.js");
  }
  void importFont();
  return jsx(Fragment, {});
};
const DahlesFont = () => {
  async function importFont() {
    await import("./dahles/index.js");
  }
  void importFont();
  return jsx(Fragment, {});
};
const GumpenFont = () => {
  async function importFont() {
    await import("./gumpen/index.js");
  }
  void importFont();
  return jsx(Fragment, {});
};
const MollerFont = () => {
  async function importFont() {
    await import("./moller/index.js");
  }
  void importFont();
  return jsx(Fragment, {});
};
const SkodaFont = () => {
  async function importFont() {
    await import("./skoda/index.js");
  }
  void importFont();
  return jsx(Fragment, {});
};
const VWFont = () => {
  async function importFont() {
    await import("./VW/index.js");
  }
  void importFont();
  return jsx(Fragment, {});
};
const ToolsFont = () => {
  async function importFont() {
    await import("./tools/index.js");
  }
  void importFont();
  return jsx(Fragment, {});
};
export {
  AudiFont,
  AutoriaFont,
  BilholdFont,
  CupraFont,
  DahlesFont,
  GumpenFont,
  MollerFont,
  SkodaFont,
  ToolsFont,
  VWFont
};
